import { render, staticRenderFns } from "./ToolsAdd.vue?vue&type=template&id=6126d706&"
import script from "./ToolsAdd.vue?vue&type=script&lang=js&"
export * from "./ToolsAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports